webpackJsonp([47],{

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(88);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale('zh-cn');
var utils = {
  timeStr: function timeStr(time) {
    var date = (0, _moment2.default)(time).format('YYYY-M-D');
    var today = (0, _moment2.default)().format('YYYY-M-D');
    var currentYear = (0, _moment2.default)().format('YYYY');
    var year = (0, _moment2.default)(time).format('YYYY');
    var yesterDay = (0, _moment2.default)().subtract(1, 'day').format('YYYY-M-D');

    if (+new Date() - time < 3600 * 1000) {
      return (0, _moment2.default)(time).fromNow();
    } else if (date === today) {
      return (0, _moment2.default)(time).format('HH:mm');
    } else if (date === yesterDay) {
      return '昨天 ' + (0, _moment2.default)(time).format('HH:mm');
    } else if (year === currentYear) {
      return (0, _moment2.default)(time).format('M月D日 HH:mm');
    } else {
      return (0, _moment2.default)(time).format('YYYY年M月D日 HH:mm');
    }
  },

  isSameDate: function isSameDate(date1, date2) {
    return utils.isSameMonth(date1, date2) && (0, _moment2.default)(date1).date() == (0, _moment2.default)(date2).date();
  },
  isSameMonth: function isSameMonth(date1, date2) {
    return utils.isSameYear(date1, date2) && (0, _moment2.default)(date1).month() == (0, _moment2.default)(date2).month();
  },
  isSameYear: function isSameYear(date1, date2) {
    return (0, _moment2.default)(date1).year() == (0, _moment2.default)(date2).year();
  }

};

exports.default = utils;

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(51);

var _vue2 = _interopRequireDefault(_vue);

var _ServiceTipTagWeb = __webpack_require__(2079);

var _ServiceTipTagWeb2 = _interopRequireDefault(_ServiceTipTagWeb);

var _qs = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _vue2.default({
  el: ".service-tip-tag-container",
  template: "\n    <service-tip-tag-web \n      :scene=\"scene\"\n      :activity-id=\"activityId\"\n      :ticket-good-id=\"ticketGroupId\"\n      :ticket-count=\"ticketCount\"\n      :order-id=\"orderId\"\n      :initTab=\"initTab\"\n      :initAnchorRefName=\"initAnchorRefName\"\n      :hiddenTabs=\"hiddenTabs\"\n    />\n  ",
  components: {
    ServiceTipTagWeb: _ServiceTipTagWeb2.default
  },
  data: function data() {
    return {
      activityId: _qs.query.activityId,
      scene: _qs.query.scene || "ACTIVITY_DETAIL",
      ticketGroupId: _qs.query.ticketGroupId,
      ticketCount: _qs.query.ticketCount,
      orderId: _qs.query.orderId,
      initTab: Number(_qs.query.initTab),
      initAnchorRefName: _qs.query.tipType ? "tip-info-" + _qs.query.tipType : "",
      hiddenTabs: _qs.query.hiddenTabs ? _qs.query.hiddenTabs : ""
    };
  },
  beforeMount: function beforeMount() {
    console.log(7777, _qs.query, this.activityId);
  }
});

/***/ }),

/***/ 1434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(766);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(453);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(452);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(87);

var _promise2 = _interopRequireDefault(_promise);

var _fetch = __webpack_require__(10);

var _fetch2 = _interopRequireDefault(_fetch);

var _activity = __webpack_require__(653);

var _activity2 = _interopRequireDefault(_activity);

var _TipInfo = __webpack_require__(2086);

var _TipInfo2 = _interopRequireDefault(_TipInfo);

var _RefundPolicy = __webpack_require__(2085);

var _RefundPolicy2 = _interopRequireDefault(_RefundPolicy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "ServiceTipTagWeb",

  components: {
    TipInfo: _TipInfo2.default,
    RefundPolicy: _RefundPolicy2.default
  },
  props: {
    scene: {
      type: String, // ACTIVITY_DETAIL
      required: true
    },
    activityId: {
      type: String,
      default: ""
    },
    ticketGoodId: {
      type: String
    },
    ticketCount: {
      type: String
    },
    orderId: {
      type: String
    },
    initTab: {
      type: Number,
      default: 0
    },
    initAnchorRefName: {
      type: String,
      default: ""
    },
    hiddenTabs: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      activeTab: this.initTab,
      scrollFix: -60,
      policyList: [],
      activity: {},
      isTabClicking: false,
      tabClickTimeout: null,
      scrollEndTimer: null,
      ticking: false
    };
  },

  watch: {
    initTab: function initTab() {
      var _this = this;

      if (this.activityId) {
        this.activeTab = newVal;
        this.$nextTick(function () {
          _this.onTabChange(newVal);
        });
      }
    },
    initAnchorRefName: function initAnchorRefName(val) {
      var _this2 = this;

      if (this.activityId) {
        this.$nextTick(function () {
          _this2.onTabChange(_this2.activeTab, val);
        });
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    if (this.activityId) {
      new _promise2.default(function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve) {
          var res;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this3.getActivity();

                case 2:
                  res = _context.sent;

                  if (res.activity) {
                    resolve(res);
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).then(function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(res) {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this3.getTips();

                case 2:
                  _this3.$nextTick(function () {
                    if (_this3.initTab !== 0 || _this3.initAnchorRefName) {
                      setTimeout(function () {
                        console.log(_this3.policyList.slice(), 8888888889);
                        _this3.onTabChange(_this3.initTab, _this3.initAnchorRefName);
                      }, 1000);
                    }
                    var allowedOrigins = ["https://wwwbeta.piaoniu.com", "https://www.piaoniu.com", "http://lc.piaoniu.com"];
                    var height = _this3.$refs["scroll-container"] && _this3.$refs["scroll-container"].scrollHeight;
                    // 把高度发送给父页面
                    allowedOrigins.forEach(function (origin) {
                      window.parent.postMessage({ type: "iframeHeight", height: height + 80 }, origin // 生产环境建议改成你的主页面域名，更安全
                      );
                    });
                    _this3.addScrollListeners();
                  });

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (err) {
        console.log(err);
      });
    } else {
      this.getTips();
    }
  },

  computed: {
    tabs: function tabs() {
      if (this.activityId) {
        return ["服务说明", "购票须知"];
      } else {
        return ["服务说明"];
      }
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    if (this.activityId) {
      this.removeScrollListeners();
    }
  },

  methods: {
    getTips: function getTips() {
      var _this4 = this;

      var params = {
        scene: this.scene
      };
      if (this.activity.id) {
        params.activityId = this.activityId;
      }
      if (this.scene === "ORDER_CONFIRM") {
        params.ticketGroups = [{
          ticketGroupId: this.ticketGoodId,
          count: this.ticketCount
        }];
      }
      if (this.scene === "ORDER_DETAIL" && this.orderId) {
        params.orderId = this.orderId;
      }
      return new _promise2.default(function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(resolve, reject) {
          return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  (0, _fetch2.default)({
                    url: "/v3/unified/tips",
                    method: "POST",
                    data: params
                  }).then(function (data) {
                    if (!data) {
                      reject();
                      return;
                    }
                    _this4.policyList = data.map(function (item) {
                      var type = item.type,
                          content = item.content,
                          displayType = item.displayType,
                          bizData = item.bizData,
                          desc = item.desc;


                      var refundRuleList = bizData && bizData.refundRuleList || [];
                      var noTicketCompensateStandardVOList = bizData && bizData.noTicketCompensateStandardVOList || [];
                      return {
                        type: type,
                        title: content,
                        canRefund: displayType === "CORRECT",
                        refundRuleList: refundRuleList,
                        noTicketCompensateStandardVOList: noTicketCompensateStandardVOList,
                        content: type === "CAN_REFUND" ? bizData && bizData.refundContent : bizData && bizData.noTicketCompensateContent,
                        tips: type === "CAN_REFUND" ? bizData && bizData.refundPolicyTips : bizData && bizData.noTicketCompensateTips || desc
                      };
                    });

                    console.log(899999999);
                    resolve();
                  }).catch(function (err) {
                    reject(err);
                  });

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, _this4);
        }));

        return function (_x3, _x4) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    getActivity: function getActivity() {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new _promise2.default(function () {
                  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(resolve, reject) {
                    var res;
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return (0, _fetch2.default)({
                              url: "/v6/activityPageDetail",
                              data: {
                                activityId: _this5.activityId,
                                supportSpeedPackBuy: true
                              }
                            });

                          case 3:
                            res = _context4.sent;


                            if (res) {
                              _this5.activity = new _activity2.default(res.activity);
                              resolve(res);
                            } else {
                              reject({});
                            }
                            _context4.next = 11;
                            break;

                          case 7:
                            _context4.prev = 7;
                            _context4.t0 = _context4["catch"](0);

                            console.error("获取活动信息失败:", _context4.t0);
                            reject({});

                          case 11:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this5, [[0, 7]]);
                  }));

                  return function (_x5, _x6) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    addScrollListeners: function addScrollListeners() {
      if (this.$refs["scroll-container"]) {
        this.$refs["scroll-container"].addEventListener("scroll", this.handleScroll);
        // this.$refs["scroll-container"].addEventListener("wheel", this.handleScroll);
        // this.$refs["scroll-container"].addEventListener("touchmove", this.handleScroll);
        // this.$refs["scroll-container"].addEventListener("keydown", this.handleScroll);
      }
    },
    removeScrollListeners: function removeScrollListeners() {
      if (this.$refs["scroll-container"]) {
        this.$refs["scroll-container"].addEventListener("scroll", this.handleScroll);
        // this.$refs["scroll-container"].removeEventListener("wheel", this.handleScroll);
        // this.$refs["scroll-container"].removeEventListener("touchmove", this.handleScroll);
        // this.$refs["scroll-container"].removeEventListener("keydown", this.handleScroll);
      }
    },
    handleScroll: function handleScroll() {
      var _this6 = this;

      if (this.scrollEndTimer) clearTimeout(this.scrollEndTimer);
      if (this.isTabClicking) {
        // 如果是由点击引起的滚动，在最后一次滚动事件后 100ms 再解除锁定，防止提前触发 activeTab 抖动
        this.scrollEndTimer = setTimeout(function () {
          _this6.isTabClicking = false;
        }, 100);
        return;
      }

      if (!this.ticking) {
        window.requestAnimationFrame(function () {
          var container = _this6.$refs["scroll-container"];
          if (!container) {
            _this6.ticking = false;
            return;
          }
          var activeIndex = 0;
          var containerRect = container.getBoundingClientRect();

          for (var i = _this6.tabs.length - 1; i >= 0; i--) {
            var ref = _this6.$refs["tab" + i + "-ref"];
            var section = ref && ref[0];
            if (section) {
              var el = section.$el || section;
              if (el && el.getBoundingClientRect) {
                var sectionRect = el.getBoundingClientRect();
                // 运用 getBoundingClientRect 判断是否滚动出容器顶部，使用 10px 容错
                if (sectionRect.top <= containerRect.top + 10) {
                  activeIndex = i;
                  break;
                }
              }
            }
          }
          if (_this6.activeTab !== activeIndex) {
            _this6.activeTab = activeIndex;
          }
          _this6.ticking = false;
        });
        this.ticking = true;
      }
    },

    // 递归查找所有子组件和slot中的ref
    findRefByName: function findRefByName(refName, component) {
      // 从当前组件开始查找
      if (component.$refs[refName]) {
        console.log("Found ref " + refName + " in component:", component.$options.name || "anonymous");
        return component.$refs[refName];
      }

      // 递归查找子组件
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(component.$children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          var _result = this.findRefByName(refName, child);
          if (_result) {
            return _result;
          }
        }

        // 查找slot中的组件
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (component.$slots) {
        for (var slotName in component.$slots) {
          var slot = component.$slots[slotName];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(slot), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var vnode = _step2.value;

              if (vnode.componentInstance) {
                var result = this.findRefByName(refName, vnode.componentInstance);
                if (result) {
                  return result;
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }

      return null;
    },
    onTabChange: function onTabChange(index, initAnchorRefName) {
      var _this7 = this;

      this.activeTab = index;

      this.isTabClicking = true;
      if (this.tabClickTimeout) clearTimeout(this.tabClickTimeout);
      // 增加防抖超时时间以作兜底
      this.tabClickTimeout = setTimeout(function () {
        _this7.isTabClicking = false;
      }, 800);

      if (this.$refs["tab" + index + "-ref"] && this.$refs["scroll-container"]) {
        var section = void 0;

        // 优先查找指定的ref
        if (initAnchorRefName) {
          var refElement = this.findRefByName(initAnchorRefName, this);
          if (refElement) {
            // 如果找到ref元素，使用它
            section = Array.isArray(refElement) ? refElement[0] : refElement;
          }
        }

        // 如果没有找到指定的ref，使用标签页的顶部
        if (!section) {
          section = this.$refs["tab" + index + "-ref"][0];
        }

        if (section) {
          var container = this.$refs["scroll-container"];
          var el = section.$el || section;

          if (el && el.getBoundingClientRect) {
            var containerRect = container.getBoundingClientRect();
            var sectionRect = el.getBoundingClientRect();

            // 使用 getBoundingClientRect 计算精准距离。减去 4px 让排版略留边距。
            var targetTop = container.scrollTop + sectionRect.top - containerRect.top - 4;

            if (typeof container.scrollTo === "function") {
              container.scrollTo({
                top: targetTop,
                behavior: "smooth"
              });
            } else {
              container.scrollTop = targetTop;
            }
          }
        }
      }
    }
  }
};

/***/ }),

/***/ 1440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RefundPolicyTable = __webpack_require__(2105);

var _RefundPolicyTable2 = _interopRequireDefault(_RefundPolicyTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconYes = "https://static.piaoniu.com/img/policy-icon2.png"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var iconNo = "https://static.piaoniu.com/img/policy-icon.png";
exports.default = {
  name: "RefundPolicy",
  components: {
    RefundPolicyTable: _RefundPolicyTable2.default
  },
  props: {
    refundPolicy: {
      type: Object,
      default: function _default() {},
      required: true
    },
    scene: {
      type: String
    },
    lastChild: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      targetPolicy: {}
    };
  },
  mounted: function mounted() {
    this.targetPolicy = this.refundPolicy.refundRuleList && this.refundPolicy.refundRuleList[0] || {};
  },

  methods: {
    selectEvent: function selectEvent(item, index) {
      this.targetPolicy = item;
      this.scroll(index);
    },
    scroll: function scroll(index) {
      var _this = this;

      this.$nextTick(function () {
        var activeOptionComp = _this.$refs["event-option-" + index];
        var element = activeOptionComp && activeOptionComp[0];
        var container = _this.$refs["scroll-container"];

        if (element && container) {
          var targetScrollLeft = element.offsetLeft;
          // 将平滑滚动时间延长至300ms以获得视觉上的连贯与丝滑
          _this.smoothScrollTo(container, targetScrollLeft, 300);
        }
      });
    },
    smoothScrollTo: function smoothScrollTo(container, target, duration) {
      // 1. 优先使用原生平滑滚动方案（性能最佳、极其丝滑）
      if (typeof container.scrollTo === "function" && "behavior" in document.documentElement.style) {
        container.scrollTo({
          left: target,
          behavior: "smooth"
        });
        return;
      }

      // 2. 降级过渡动画方案
      var start = container.scrollLeft;
      var change = target - start;
      if (change === 0) return;

      var startTime = performance.now();
      var animateScroll = function animateScroll(currentTime) {
        var elapsed = currentTime - startTime;
        var progress = elapsed / duration;
        if (progress > 1) progress = 1;

        // 使用 easeOutQuart 特效：启动迅捷，逐渐无比轻缓地停下
        var ease = 1 - Math.pow(1 - progress, 4);
        container.scrollLeft = start + change * ease;

        if (progress < 1) {
          window.requestAnimationFrame(animateScroll);
        }
      };

      window.requestAnimationFrame(animateScroll);
    }
  },
  computed: {
    icon: function icon() {
      return this.refundPolicy.title === "预售" || this.refundPolicy.title === "不支持退" ? iconNo : iconYes;
    },
    hasTable: function hasTable() {
      return this.refundPolicy.refundRuleList && this.refundPolicy.refundRuleList.length || this.refundPolicy.noTicketCompensateStandardVOList && this.refundPolicy.noTicketCompensateStandardVOList.length;
    }
  }
};

/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(359);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//

var baseUrl = "https://static.piaoniu.com/pn/public/gpxz/";

exports.default = {
  props: {
    activity: Object
  },
  data: function data() {
    return {
      baseUrl: baseUrl,
      tabActive: 1
    };
  },

  computed: {
    detailDesc: function detailDesc() {
      var _activity = this.activity,
          ticketTip = _activity.ticketTip,
          enterTip = _activity.enterTip;

      console.log("detailDesc", [].concat((0, _toConsumableArray3.default)(ticketTip.detail), (0, _toConsumableArray3.default)(enterTip.detail)));
      return [].concat((0, _toConsumableArray3.default)(ticketTip.detail), (0, _toConsumableArray3.default)(enterTip.detail));
    }
  },
  methods: {
    selectTab: function selectTab(index) {
      this.tabActive = index;
    },
    replaceWrap: function replaceWrap(str) {
      return str.replace(/\n/g, "<br/>");
    }
  }
};

/***/ }),

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(88);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var refundType = { FREE: "免费退票", FORBIDDEN: "停止退票", TICKET_AMOUNT_PERCENT: "票款金额" }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "RefundPolicyTable",
  data: function data() {
    return {
      nowTime: new Date().getTime()
    };
  },

  props: {
    policyObj: {
      type: Object,
      default: function _default() {}
    },
    policyArray: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      required: true
    },
    scene: {
      type: String
    }
  },
  computed: {
    event: function event() {
      return (this.policyObj && this.policyObj.relations || []).map(function (item) {
        return item.name;
      }).join("、");
    },
    policyList: function policyList() {
      var _this = this;

      this.nowTime = new Date().getTime();
      return (this.policyObj && this.policyObj.ruleDetails || []).map(function (item) {
        var time = (0, _moment2.default)(item.startTime).format("MM/DD HH:mm") + "\u81F3" + (0, _moment2.default)(item.endTime).format("MM/DD HH:mm");
        var mode = refundType[item.refundMode] + (item.refundMode === "TICKET_AMOUNT_PERCENT" ? item.refundAmount + "%" : "");
        return {
          time: time,
          active: item.startTime <= _this.nowTime && item.endTime >= _this.nowTime,
          expired: item.endTime < _this.nowTime,
          mode: mode,
          id: item.id
        };
      });
    }
  }
};

/***/ }),

/***/ 1684:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.tip-detail__item[data-v-3f660ab7]::after {\n  content: \"\";\n  display: block;\n  margin-bottom: 12px;\n  width: 100%;\n  height: 1px;\n  background-color: #f5f5f5;\n}\n.tip-detail__item[data-v-3f660ab7]:last-child::after {\n  display: none;\n}\n.tip-detail__item-title[data-v-3f660ab7] {\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #262626;\n}\n.tip-detail__item-desc[data-v-3f660ab7] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px;\n  margin: 6px 0 12px;\n}\n", "", {"version":3,"sources":["/./src/activity/detail/common/TipInfo.vue"],"names":[],"mappings":";AAAA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,0BAA0B;CAC3B;AACD;EACE,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;CAChB;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;CACpB","file":"TipInfo.vue","sourcesContent":[".tip-detail__item::after {\n  content: \"\";\n  display: block;\n  margin-bottom: 12px;\n  width: 100%;\n  height: 1px;\n  background-color: #f5f5f5;\n}\n.tip-detail__item:last-child::after {\n  display: none;\n}\n.tip-detail__item-title {\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #262626;\n}\n.tip-detail__item-desc {\n  color: #666666;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px;\n  margin: 6px 0 12px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),

/***/ 1685:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.popup-content[data-v-409dc3d4] {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  box-sizing: border-box;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #f5f5f5;\n  border-radius: 24px 24px 0 0;\n  overflow: hidden;\n  height: 100vh;\n  position: relative;\n}\n.popup-head[data-v-409dc3d4] {\n  height: 56px;\n  -webkit-flex-shrink: 0;\n          flex-shrink: 0;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 18.49%);\n  border-radius: 24px 24px 0 0;\n  position: relative;\n  z-index: 10;\n}\n.popup-tabs[data-v-409dc3d4] {\n  display: -webkit-flex;\n  display: flex;\n  width: 100%;\n  padding: 0 16px;\n  box-sizing: border-box;\n}\n.popup-tab-item[data-v-409dc3d4] {\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 1;\n  color: #999999;\n  margin-right: 18px;\n  position: relative;\n  cursor: pointer;\n}\n.popup-tab-item-active[data-v-409dc3d4] {\n  font-weight: 500;\n  color: #262626;\n}\n.popup-body[data-v-409dc3d4] {\n  -webkit-flex: 1;\n          flex: 1;\n  overflow: auto;\n  padding: 0 12px 50px;\n  -webkit-overflow-scrolling: touch;\n  /* 仅移动端必要 */\n}\n.popup-body[data-v-409dc3d4]::-webkit-scrollbar {\n  display: none;\n}\n.popup-section[data-v-409dc3d4] {\n  padding: 14px 12px;\n  box-shadow: 0px 2px 5px 0px #d8def40d;\n  background: #ffffff;\n  border-radius: 12px;\n  margin-bottom: 12px;\n}\n.popup-section[data-v-409dc3d4]::last-child {\n  margin-bottom: 0;\n}\n.popup-section-title[data-v-409dc3d4] {\n  font-family: PingFang SC;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 1;\n  color: #262626;\n  margin-bottom: 14px;\n}\n.popup-fade-enter-active[data-v-409dc3d4],\n.popup-fade-leave-active[data-v-409dc3d4] {\n  transition: opacity 0.3s ease;\n}\n.popup-fade-enter[data-v-409dc3d4],\n.popup-fade-leave-to[data-v-409dc3d4] {\n  opacity: 0;\n}\n.popup-slide-enter-active[data-v-409dc3d4] {\n  transition: -webkit-transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), -webkit-transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n.popup-slide-leave-active[data-v-409dc3d4] {\n  transition: -webkit-transform 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  transition: transform 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  transition: transform 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53), -webkit-transform 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);\n}\n.popup-slide-enter[data-v-409dc3d4],\n.popup-slide-leave-to[data-v-409dc3d4] {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n", "", {"version":3,"sources":["/./src/about/ServiceTipTagWeb.vue"],"names":[],"mappings":";AAAA;EACE,sBAAc;EAAd,cAAc;EACd,+BAAuB;UAAvB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,uBAAe;UAAf,eAAe;EACf,sBAAc;EAAd,cAAc;EACd,4BAAoB;UAApB,oBAAoB;EACpB,gEAAgE;EAChE,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,sBAAc;EAAd,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;CACxB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,gBAAQ;UAAR,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;CACrB;AACD;;EAEE,8BAA8B;CAC/B;AACD;;EAEE,WAAW;CACZ;AACD;EACE,yEAAiE;EAAjE,iEAAiE;EAAjE,+HAAiE;CAClE;AACD;EACE,yEAAiE;EAAjE,iEAAiE;EAAjE,+HAAiE;CAClE;AACD;;EAEE,oCAA4B;UAA5B,4BAA4B;CAC7B","file":"ServiceTipTagWeb.vue","sourcesContent":[".popup-content {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #f5f5f5;\n  border-radius: 24px 24px 0 0;\n  overflow: hidden;\n  height: 100vh;\n  position: relative;\n}\n.popup-head {\n  height: 56px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 18.49%);\n  border-radius: 24px 24px 0 0;\n  position: relative;\n  z-index: 10;\n}\n.popup-tabs {\n  display: flex;\n  width: 100%;\n  padding: 0 16px;\n  box-sizing: border-box;\n}\n.popup-tab-item {\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 1;\n  color: #999999;\n  margin-right: 18px;\n  position: relative;\n  cursor: pointer;\n}\n.popup-tab-item-active {\n  font-weight: 500;\n  color: #262626;\n}\n.popup-body {\n  flex: 1;\n  overflow: auto;\n  padding: 0 12px 50px;\n  -webkit-overflow-scrolling: touch;\n  /* 仅移动端必要 */\n}\n.popup-body::-webkit-scrollbar {\n  display: none;\n}\n.popup-section {\n  padding: 14px 12px;\n  box-shadow: 0px 2px 5px 0px #d8def40d;\n  background: #ffffff;\n  border-radius: 12px;\n  margin-bottom: 12px;\n}\n.popup-section::last-child {\n  margin-bottom: 0;\n}\n.popup-section-title {\n  font-family: PingFang SC;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 1;\n  color: #262626;\n  margin-bottom: 14px;\n}\n.popup-fade-enter-active,\n.popup-fade-leave-active {\n  transition: opacity 0.3s ease;\n}\n.popup-fade-enter,\n.popup-fade-leave-to {\n  opacity: 0;\n}\n.popup-slide-enter-active {\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n.popup-slide-leave-active {\n  transition: transform 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);\n}\n.popup-slide-enter,\n.popup-slide-leave-to {\n  transform: translateY(100%);\n}\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),

/***/ 1717:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "/* 最外层容器（提供外边框和圆角） */\n.t[data-v-7181e042] {\n  margin: 8px 0;\n  border-radius: 6px;\n  border: 1px solid #f2f2f2;\n  overflow: hidden;\n  background-color: #ffffff;\n}\n/* 表头背景 */\n.t-head[data-v-7181e042] {\n  background-color: #f5f5f5;\n}\n/* Grid 行基础样式 */\n.t-tr[data-v-7181e042] {\n  display: grid;\n  width: 100%;\n  min-height: 37px;\n  border-bottom: 1px solid #f2f2f2;\n  /* 横向网格线 */\n  font-size: 13px;\n  /* 场景一：左侧 125px，右侧自适应 */\n  /* 场景二：左侧自适应，右侧 120px */\n  /* 当前激活态样式 */\n  /* 过期状态样式 */\n}\n.t-tr-compensate[data-v-7181e042] {\n  grid-template-columns: 125px 1fr;\n}\n.t-tr-refund[data-v-7181e042] {\n  grid-template-columns: 1fr 120px;\n}\n.t-tr-active[data-v-7181e042] {\n  background: linear-gradient(90deg, #ffeff4 0%, #ffffff 35%);\n}\n.t-tr-expired .t-td[data-v-7181e042] {\n  color: #868c98;\n  text-decoration: line-through;\n}\n/* 消除最后一行的底部网格线，防止与外边框叠加变粗 */\n.t-body .t-tr[data-v-7181e042]:last-child {\n  border-bottom: none;\n}\n/* 单元格公共样式 */\n.t-td[data-v-7181e042] {\n  font-family: PingFang SC;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 16px;\n  color: #262626;\n  box-sizing: border-box;\n  padding: 8px 12px;\n  display: -webkit-flex;\n  display: flex;\n  overflow: visible !important;\n  -webkit-align-items: center;\n          align-items: center;\n  /* 保证文字在多行时依然垂直居中 */\n  /* 纵向网格线：仅给每行的第一个单元格加右边框即可 */\n  /* 当前阶段 Tag */\n}\n.t-td[data-v-7181e042]:first-child {\n  border-right: 1px solid #f2f2f2;\n}\n.t-td .co-tag[data-v-7181e042] {\n  padding: 2px 0;\n}\n.t-td-activetag[data-v-7181e042] {\n  border-style: solid;\n  border-width: 1px;\n  border-color: #ff2661;\n  border-radius: 6px;\n  margin-left: 4px;\n  font-weight: 600;\n  font-size: 9px;\n  line-height: 1.5;\n  color: #ff2661;\n  padding: 2px 5px;\n  white-space: nowrap;\n  position: relative;\n  z-index: 999;\n}\n/* 表头字体加粗 */\n.t-th[data-v-7181e042] {\n  font-weight: 500;\n  color: #20232d;\n  font-size: 11px;\n}\n", "", {"version":3,"sources":["/./src/components/RefundPolicyTable.vue"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,0BAA0B;CAC3B;AACD,UAAU;AACV;EACE,0BAA0B;CAC3B;AACD,gBAAgB;AAChB;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,aAAa;EACb,YAAY;CACb;AACD;EACE,iCAAiC;CAClC;AACD;EACE,iCAAiC;CAClC;AACD;EACE,4DAA4D;CAC7D;AACD;EACE,eAAe;EACf,8BAA8B;CAC/B;AACD,6BAA6B;AAC7B;EACE,oBAAoB;CACrB;AACD,aAAa;AACb;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,sBAAc;EAAd,cAAc;EACd,6BAA6B;EAC7B,4BAAoB;UAApB,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;CACf;AACD;EACE,gCAAgC;CACjC;AACD;EACE,eAAe;CAChB;AACD;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;CACd;AACD,YAAY;AACZ;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;CACjB","file":"RefundPolicyTable.vue","sourcesContent":["/* 最外层容器（提供外边框和圆角） */\n.t {\n  margin: 8px 0;\n  border-radius: 6px;\n  border: 1px solid #f2f2f2;\n  overflow: hidden;\n  background-color: #ffffff;\n}\n/* 表头背景 */\n.t-head {\n  background-color: #f5f5f5;\n}\n/* Grid 行基础样式 */\n.t-tr {\n  display: grid;\n  width: 100%;\n  min-height: 37px;\n  border-bottom: 1px solid #f2f2f2;\n  /* 横向网格线 */\n  font-size: 13px;\n  /* 场景一：左侧 125px，右侧自适应 */\n  /* 场景二：左侧自适应，右侧 120px */\n  /* 当前激活态样式 */\n  /* 过期状态样式 */\n}\n.t-tr-compensate {\n  grid-template-columns: 125px 1fr;\n}\n.t-tr-refund {\n  grid-template-columns: 1fr 120px;\n}\n.t-tr-active {\n  background: linear-gradient(90deg, #ffeff4 0%, #ffffff 35%);\n}\n.t-tr-expired .t-td {\n  color: #868c98;\n  text-decoration: line-through;\n}\n/* 消除最后一行的底部网格线，防止与外边框叠加变粗 */\n.t-body .t-tr:last-child {\n  border-bottom: none;\n}\n/* 单元格公共样式 */\n.t-td {\n  font-family: PingFang SC;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 16px;\n  color: #262626;\n  box-sizing: border-box;\n  padding: 8px 12px;\n  display: flex;\n  overflow: visible !important;\n  align-items: center;\n  /* 保证文字在多行时依然垂直居中 */\n  /* 纵向网格线：仅给每行的第一个单元格加右边框即可 */\n  /* 当前阶段 Tag */\n}\n.t-td:first-child {\n  border-right: 1px solid #f2f2f2;\n}\n.t-td .co-tag {\n  padding: 2px 0;\n}\n.t-td-activetag {\n  border-style: solid;\n  border-width: 1px;\n  border-color: #ff2661;\n  border-radius: 6px;\n  margin-left: 4px;\n  font-weight: 600;\n  font-size: 9px;\n  line-height: 1.5;\n  color: #ff2661;\n  padding: 2px 5px;\n  white-space: nowrap;\n  position: relative;\n  z-index: 999;\n}\n/* 表头字体加粗 */\n.t-th {\n  font-weight: 500;\n  color: #20232d;\n  font-size: 11px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),

/***/ 1724:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.policy[data-v-857e2c08] {\n  background-color: #ffffff;\n  position: relative;\n  box-sizing: border-box;\n}\n.after-bottom-divider[data-v-857e2c08]::after {\n  content: \"\";\n  display: block;\n  margin-bottom: 12px;\n  width: 100%;\n  height: 1px;\n  background-color: #f5f5f5;\n}\n.policy-icon[data-v-857e2c08] {\n  margin-right: 2px;\n  width: 18px;\n  height: 18px;\n}\n.policy-title[data-v-857e2c08] {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  margin-bottom: 6px;\n  font-family: PingFang SC;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #262626;\n}\n.policy-tips[data-v-857e2c08],\n.policy-content[data-v-857e2c08] {\n  margin: 6px 0 12px;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px;\n  color: #666666;\n  white-space: pre-wrap;\n}\n.policy-tab-container .event-options[data-v-857e2c08] {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: flex-start;\n          align-items: flex-start;\n  overflow-x: auto;\n  width: 100%;\n  padding-bottom: 6.5px;\n  position: relative;\n}\n.policy-tab-container .event-options[data-v-857e2c08]::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari, Opera*/\n}\n.policy-tab-container .event-options .event-options-item[data-v-857e2c08] {\n  padding: 10px;\n  background: #f5f5f5;\n  color: #262626;\n  border-radius: 8px;\n  margin-right: 8px;\n  font-family: PingFang SC;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 16px;\n  white-space: nowrap;\n  box-sizing: border-box;\n  -webkit-text-size-adjust: none;\n          text-size-adjust: none;\n  min-width: -webkit-fit-content;\n  min-width: fit-content;\n  /* Webview 点击与交互兼容性增强 */\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: pan-x;\n  /* 防止横向滑动误触 */\n}\n.policy-tab-container .event-options .event-options-item-active[data-v-857e2c08] {\n  background: #fef2f5;\n  position: relative;\n  z-index: 1;\n  border: 1px solid #ff2261;\n}\n.policy-tab-container .event-options .event-options-item-active[data-v-857e2c08]::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  bottom: 1px;\n  left: 50%;\n  width: 22px;\n  height: 7px;\n  -webkit-transform: translate(-50%, 100%);\n          transform: translate(-50%, 100%);\n  background: url(\"https://static.piaoniu.com/event-active-icon.png\");\n  background-size: 100% 7px;\n  background-repeat: no-repeat;\n  background-position: center -1px;\n  z-index: 50;\n  border-top: 1px solid #fef2f5;\n}\n", "", {"version":3,"sources":["/./src/activity/detail/RefundPolicy.vue"],"names":[],"mappings":";AAAA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;CACxB;AACD;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,0BAA0B;CAC3B;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;CACd;AACD;EACE,sBAAc;EAAd,cAAc;EACd,4BAAoB;UAApB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;CAChB;AACD;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;CACvB;AACD;EACE,sBAAc;EAAd,cAAc;EACd,gCAAwB;UAAxB,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;CACpB;AACD;EACE,cAAc;EACd,0BAA0B;CAC3B;AACD;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,+BAAuB;UAAvB,uBAAuB;EACvB,+BAAuB;EAAvB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,yCAAyC;EACzC,oBAAoB;EACpB,cAAc;CACf;AACD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;CAC3B;AACD;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,yCAAiC;UAAjC,iCAAiC;EACjC,oEAAoE;EACpE,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,8BAA8B;CAC/B","file":"RefundPolicy.vue","sourcesContent":[".policy {\n  background-color: #ffffff;\n  position: relative;\n  box-sizing: border-box;\n}\n.after-bottom-divider::after {\n  content: \"\";\n  display: block;\n  margin-bottom: 12px;\n  width: 100%;\n  height: 1px;\n  background-color: #f5f5f5;\n}\n.policy-icon {\n  margin-right: 2px;\n  width: 18px;\n  height: 18px;\n}\n.policy-title {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  font-family: PingFang SC;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #262626;\n}\n.policy-tips,\n.policy-content {\n  margin: 6px 0 12px;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px;\n  color: #666666;\n  white-space: pre-wrap;\n}\n.policy-tab-container .event-options {\n  display: flex;\n  align-items: flex-start;\n  overflow-x: auto;\n  width: 100%;\n  padding-bottom: 6.5px;\n  position: relative;\n}\n.policy-tab-container .event-options::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari, Opera*/\n}\n.policy-tab-container .event-options .event-options-item {\n  padding: 10px;\n  background: #f5f5f5;\n  color: #262626;\n  border-radius: 8px;\n  margin-right: 8px;\n  font-family: PingFang SC;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 16px;\n  white-space: nowrap;\n  box-sizing: border-box;\n  text-size-adjust: none;\n  min-width: fit-content;\n  /* Webview 点击与交互兼容性增强 */\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: pan-x;\n  /* 防止横向滑动误触 */\n}\n.policy-tab-container .event-options .event-options-item-active {\n  background: #fef2f5;\n  position: relative;\n  z-index: 1;\n  border: 1px solid #ff2261;\n}\n.policy-tab-container .event-options .event-options-item-active::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  bottom: 1px;\n  left: 50%;\n  width: 22px;\n  height: 7px;\n  transform: translate(-50%, 100%);\n  background: url(\"https://static.piaoniu.com/event-active-icon.png\");\n  background-size: 100% 7px;\n  background-repeat: no-repeat;\n  background-position: center -1px;\n  z-index: 50;\n  border-top: 1px solid #fef2f5;\n}\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),

/***/ 2079:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2365)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1434),
  /* template */
  __webpack_require__(2240),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-409dc3d4",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/mnt/devops/workspace/mweb-info/src/about/ServiceTipTagWeb.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ServiceTipTagWeb.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-409dc3d4", Component.options)
  } else {
    hotAPI.reload("data-v-409dc3d4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2085:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2404)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1440),
  /* template */
  __webpack_require__(2278),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-857e2c08",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/mnt/devops/workspace/mweb-info/src/activity/detail/RefundPolicy.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RefundPolicy.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-857e2c08", Component.options)
  } else {
    hotAPI.reload("data-v-857e2c08", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2086:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2364)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1441),
  /* template */
  __webpack_require__(2239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f660ab7",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/mnt/devops/workspace/mweb-info/src/activity/detail/common/TipInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TipInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3f660ab7", Component.options)
  } else {
    hotAPI.reload("data-v-3f660ab7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2105:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2397)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1460),
  /* template */
  __webpack_require__(2271),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7181e042",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/mnt/devops/workspace/mweb-info/src/components/RefundPolicyTable.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RefundPolicyTable.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7181e042", Component.options)
  } else {
    hotAPI.reload("data-v-7181e042", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2239:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-detail"
  }, [_c('div', {
    staticClass: "tip-detail__desc"
  }, _vm._l((_vm.detailDesc), function(item) {
    return _c('div', {
      key: item.type,
      ref: ("tip-info-" + (item.type)),
      refInFor: true,
      staticClass: "tip-detail__item"
    }, [_c('div', {
      staticClass: "tip-detail__item-title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "tip-detail__item-desc",
      domProps: {
        "innerHTML": _vm._s(_vm.replaceWrap(item.desc))
      }
    })])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f660ab7", module.exports)
  }
}

/***/ }),

/***/ 2240:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.policyList.length) ? _c('div', {
    staticClass: "service-tip-tag-web"
  }, [_c('div', {
    staticClass: "popup-content"
  }, [(!_vm.hiddenTabs) ? _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "popup-tabs"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('div', {
      key: index,
      staticClass: "popup-tab-item",
      class: {
        'popup-tab-item-active': _vm.activeTab === index || _vm.tabs.length === 1
      },
      on: {
        "click": function($event) {
          return _vm.onTabChange(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab) + "\n        ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "scroll-container",
    staticClass: "popup-body",
    style: (_vm.hiddenTabs ? 'margin-top:16px;' : '')
  }, _vm._l((_vm.tabs), function(tabName, index) {
    return _c('div', {
      key: ("tab" + index),
      ref: ("tab" + index + "-ref"),
      refInFor: true,
      staticClass: "popup-section"
    }, [(index === 0 && _vm.policyList.length) ? [_c('div', {
      staticClass: "popup-section-title"
    }, [_vm._v(_vm._s(tabName))]), _vm._v(" "), _vm._l((_vm.policyList), function(item, index) {
      return _c('refund-policy', {
        key: index,
        attrs: {
          "refund-policy": item,
          "scene": "TAG",
          "last-child": _vm.policyList.length - 1 === index
        }
      })
    })] : _vm._e(), _vm._v(" "), (index === 1) ? [_c('div', {
      staticClass: "popup-section-title"
    }, [_vm._v(_vm._s(tabName))]), _vm._v(" "), (_vm.activity.id) ? _c('tip-info', {
      attrs: {
        "activity": _vm.activity
      }
    }) : _vm._e()] : _vm._e()], 2)
  }), 0)])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-409dc3d4", module.exports)
  }
}

/***/ }),

/***/ 2271:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type === 'NO_TICKET_COMPENSATE') ? _c('div', {
    staticClass: "t"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "t-body"
  }, _vm._l((_vm.policyArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "t-tr t-tr-compensate"
    }, [_c('div', {
      staticClass: "t-td"
    }, [_vm._v(_vm._s(item.noTicketCompensateMatchStr))]), _vm._v(" "), _c('div', {
      staticClass: "t-td"
    }, [_vm._v(_vm._s(item.noTicketCompensateModeStr))])])
  }), 0)]) : _c('div', {
    staticClass: "t"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "t-body"
  }, _vm._l((_vm.policyList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "t-tr t-tr-refund",
      class: {
        't-tr-active': item.active,
        't-tr-expired': item.expired
      }
    }, [_c('div', {
      staticClass: "t-td"
    }, [_c('span', {
      staticClass: "co-tag"
    }, [_vm._v(_vm._s(item.time))]), (item.active) ? _c('span', {
      staticClass: "t-td-activetag"
    }, [_vm._v("当前阶段")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "t-td"
    }, [_vm._v(_vm._s(item.mode))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t-head"
  }, [_c('div', {
    staticClass: "t-tr t-tr-compensate"
  }, [_c('div', {
    staticClass: "t-th t-td"
  }, [_vm._v("告知无票时间")]), _vm._v(" "), _c('div', {
    staticClass: "t-th t-td"
  }, [_vm._v("赔付比例")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t-head"
  }, [_c('div', {
    staticClass: "t-tr t-tr-refund"
  }, [_c('div', {
    staticClass: "t-th t-td"
  }, [_vm._v("申请退票时间")]), _vm._v(" "), _c('div', {
    staticClass: "t-th t-td"
  }, [_vm._v("退票手续费")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7181e042", module.exports)
  }
}

/***/ }),

/***/ 2278:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "policy",
    class: {
      'after-bottom-divider': !(_vm.lastChild || (_vm.hasTable && !_vm.refundPolicy.tips)),
    }
  }, [(_vm.scene === 'TAG') ? _c('div', {
    staticClass: "policy-title"
  }, [_c('img', {
    staticClass: "policy-icon",
    attrs: {
      "src": _vm.icon
    }
  }), _vm._v(_vm._s(_vm.refundPolicy.title))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.refundPolicy.content) ? _c('div', {
    staticClass: "policy-content",
    style: (!_vm.hasTable && _vm.refundPolicy.tips && _vm.refundPolicy.content ? 'margin-bottom:0;' : '')
  }, [_vm._v(_vm._s(_vm.refundPolicy.content))]) : _vm._e(), _vm._v(" "), (_vm.refundPolicy.refundRuleList && _vm.refundPolicy.refundRuleList.length) ? [_c('div', {
    staticClass: "policy-tab-container"
  }, [_c('div', {
    ref: "scroll-container",
    staticClass: "event-options"
  }, _vm._l((_vm.refundPolicy.refundRuleList), function(item, index) {
    return _c('div', {
      key: item.name || index,
      ref: ("event-option-" + index),
      refInFor: true,
      class: ['event-options-item', _vm.targetPolicy.name === item.name ? 'event-options-item-active' : ''],
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.selectEvent(item, index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('refund-policy-table', {
    attrs: {
      "policy-obj": _vm.targetPolicy,
      "type": "REFUND"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.refundPolicy.noTicketCompensateStandardVOList && _vm.refundPolicy.noTicketCompensateStandardVOList.length) ? [_c('refund-policy-table', {
    attrs: {
      "policy-array": _vm.refundPolicy.noTicketCompensateStandardVOList,
      "type": _vm.refundPolicy.type
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "policy-tips",
    style: (!_vm.hasTable && _vm.refundPolicy.tips && _vm.refundPolicy.content ? 'margin-top:0;' : '')
  }, [_vm._v(_vm._s(_vm.refundPolicy.tips))])], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-857e2c08", module.exports)
  }
}

/***/ }),

/***/ 2364:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1684);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7e96b530", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3f660ab7\",\"scoped\":true,\"hasInlineConfig\":true}!../../../../node_modules/less-loader/index.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TipInfo.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3f660ab7\",\"scoped\":true,\"hasInlineConfig\":true}!../../../../node_modules/less-loader/index.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TipInfo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2365:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1685);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("baa6ba08", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-409dc3d4\",\"scoped\":true,\"hasInlineConfig\":true}!../../node_modules/less-loader/index.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ServiceTipTagWeb.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-409dc3d4\",\"scoped\":true,\"hasInlineConfig\":true}!../../node_modules/less-loader/index.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ServiceTipTagWeb.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2397:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1717);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3ee0c632", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7181e042\",\"scoped\":true,\"hasInlineConfig\":true}!../../node_modules/less-loader/index.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RefundPolicyTable.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7181e042\",\"scoped\":true,\"hasInlineConfig\":true}!../../node_modules/less-loader/index.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RefundPolicyTable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2404:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1724);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d5335392", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-857e2c08\",\"scoped\":true,\"hasInlineConfig\":true}!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RefundPolicy.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-857e2c08\",\"scoped\":true,\"hasInlineConfig\":true}!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RefundPolicy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2495:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(4);
module.exports = __webpack_require__(1277);


/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(367);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(368), __esModule: true };

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(263);
__webpack_require__(372);
module.exports = __webpack_require__(83).Array.from;


/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(128);
var createDesc = __webpack_require__(402);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(93);
var $export = __webpack_require__(70);
var toObject = __webpack_require__(258);
var call = __webpack_require__(471);
var isArrayIter = __webpack_require__(470);
var toLength = __webpack_require__(327);
var createProperty = __webpack_require__(369);
var getIterFn = __webpack_require__(461);

$export($export.S + $export.F * !__webpack_require__(472)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(768);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(37);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(771);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(770);

var _inherits3 = _interopRequireDefault(_inherits2);

var _model = __webpack_require__(758);

var _model2 = _interopRequireDefault(_model);

var _dateutil = __webpack_require__(105);

var _dateutil2 = _interopRequireDefault(_dateutil);

var _moment = __webpack_require__(88);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activity = function (_Model) {
  (0, _inherits3.default)(Activity, _Model);

  function Activity(data) {
    (0, _classCallCheck3.default)(this, Activity);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Activity.__proto__ || (0, _getPrototypeOf2.default)(Activity)).call(this));

    var getterMethods = {
      canBuy: function canBuy() {
        return this.status === 1 || this.status === 4;
      },
      statusText: function statusText() {
        var result = {
          1: "售票中",
          2: "已停售",
          3: "已结束",
          4: "预售中",
          5: "退票中",
          6: "待开售",
          0: "暂时缺票"
        }[this.status];
        return result;
      },

      duration: function duration() {
        var event = (this.events || [])[0];
        if (!event) {
          return "";
        }

        if (!event.end) {
          return "";
        }

        var seconds = event.end - event.start;

        var minutes = Math.ceil(seconds / 60 / 1000);
        var result = minutes + "\u5206\u949F";
        return result;
      },
      availableEvents: function availableEvents() {
        if (this.events) {
          var events = this.events;
          if (!this._availableEvents) {
            this._availableEvents = events.filter(function (event) {
              return event.status == 1 && event.ticketsNumber;
            });
          }
          return this._availableEvents;
        } else return "";
      },
      period: function period() {
        var events = this.events;
        var formatYMD = "YYYY年M月D日";
        var formatMD = "M月D日";
        var formatD = "D日";

        if (!events || !events.length) {
          return "";
        } else if (events.length == 1) {
          return (0, _moment2.default)(events[0].start).format(formatYMD);
        } else {
          var firstEvent = events[0];
          var lastEvent = events[events.length - 1];

          var from = (0, _moment2.default)(firstEvent.start).format(formatYMD);
          var to;

          if (_dateutil2.default.isSameDate(firstEvent.start, lastEvent.start)) {
            return from;
          }

          if (_dateutil2.default.isSameMonth(firstEvent.start, lastEvent.start)) {
            to = (0, _moment2.default)(lastEvent.start).format(formatD);
          } else if (_dateutil2.default.isSameYear) {
            to = (0, _moment2.default)(lastEvent.start).format(formatMD);
          } else {
            to = (0, _moment2.default)(lastEvent.start).format(formatYMD);
          }

          return from + " - " + to;
        }
      }
    };
    // data.generalAgency = false
    // data.status = 6
    // data.showStartRemind = true
    // data.startSellTime = 1507632823163
    if (data.duration) delete getterMethods.duration;
    if (data.timeRange) {
      getterMethods.period = function () {
        return data.timeRange;
      };
    }

    _this.setDataForInstance(data, getterMethods);
    return _this;
  }

  return Activity;
}(_model2.default);

exports.default = Activity;

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(37);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(52);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Model = function () {
  function Model() {
    (0, _classCallCheck3.default)(this, Model);
  }

  (0, _createClass3.default)(Model, [{
    key: "setDataForInstance",
    value: function setDataForInstance(data, getterMethods) {
      var key;
      for (key in data) {
        if (!getterMethods[key]) {
          this[key] = data[key];
        }
      }
      if (getterMethods) {
        for (key in getterMethods) {
          this[key] = getterMethods[key].apply(this);
        }
      } else {
        for (key in data) {
          this[key] = data[key];
        }
      }
    }
  }]);
  return Model;
}();

exports.default = Model;

/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(772), __esModule: true };

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(773), __esModule: true };

/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(769);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(767);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(139);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(139);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(787);
var $Object = __webpack_require__(83).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(788);
module.exports = __webpack_require__(83).Object.setPrototypeOf;


/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(86);
var anObject = __webpack_require__(401);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(93)(Function.call, __webpack_require__(777).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(70);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(353) });


/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(70);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(779).set });


/***/ })

},[2495]);


// WEBPACK FOOTER //
// static/js/about/serviceTipTagWeb.3542990c.js